import SegmentedBar from 'components/SegmentedBar';
import { useAtomValue } from 'jotai';
import React from 'react';
import { Card } from 'reactstrap';

import { assetDataAtom } from './state';

const InsightItem: React.FC<{
  label: string;
  value: number;
  isLast?: boolean;
}> = ({ label, value, isLast = false }) => (
  <div
    className={`flex-grow-0 flex-shrink-0 border-right ${
      isLast ? '' : 'mr-2 pr-2'
    }`}
    style={{
      width: '150px',
      borderColor: '#dee2e6',
      ...(isLast && { borderRight: 'none' }), // Remove border for the last item
    }}
  >
    <div className="text-center">
      <h6 className="mb-0">{label}</h6>
      <h5 className="font-weight-bold mb-0">{value}</h5>
    </div>
  </div>
);

const AssetInsights: React.FC = () => {
  const assetData = useAtomValue(assetDataAtom);
  const insights = assetData?.insights;

  if (!insights) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container-fluid border border-light rounded p-0 mb-1">
      <Card
        className="mb-0 px-3 py-1"
        style={{ backgroundColor: 'rgba(34, 42, 66, 0.02)' }}
      >
        <div className="d-flex flex-wrap align-items-center">
          {/* Compliance Status */}
          <div
            className="mr-2 pr-2 flex-grow-1 border-right"
            style={{ borderColor: '#dee2e6' }}
          >
            <h6 className="mb-0">Compliance Status:</h6>
            <SegmentedBar
              height="5px"
              width="100%"
              segments={[
                {
                  color: 'danger',
                  value: insights.total_failed_postures,
                  label: 'Failed',
                },
                {
                  color: 'success',
                  value: insights.total_passed_postures,
                  label: 'Passed',
                },
              ]}
              labelDisplay="value"
              tooltip={`Failed: ${insights.total_failed_postures}, Passed: ${insights.total_passed_postures}`}
            />
          </div>

          {/* Count Summaries */}
          {/* Unique Policy Count */}
          <InsightItem label="Policies" value={insights.unique_policy_count} />
          <InsightItem label="Assets" value={insights.total} />
          <InsightItem
            label="Findings"
            value={
              insights.total_failed_postures + insights.total_passed_postures
            }
          />
          <InsightItem
            label="Operating&nbsp;Systems"
            value={insights.unique_os_count}
            isLast={true}
          />
        </div>
      </Card>
    </div>
  );
};

export default AssetInsights;
